// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-brand-color-picker .color-preview-card {
  display: inline-block;
  margin-right: 20px;
  width: 100px;
  height: 100px;
  text-align: center;
  border-radius: 10px;
  margin-bottom: 10px;
  position: relative;
  cursor: pointer;
}
.fi-brand-color-picker .color-preview-card:hover .paint-icon {
  opacity: 1;
}
.fi-brand-color-picker .color-preview-card .paint-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 0;
  transition: 0.2s;
  color: var(--fi-color-white);
}
.fi-brand-color-picker .color-preview-card .color-picker-trigger {
  opacity: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
}
.fi-brand-color-picker .color-preview-card .color-picker-button {
  margin: 0;
  font-size: 12px;
  border: none;
  background: transparent;
}
.fi-brand-color-picker .color-preview-card .color-picker-button.cancel {
  float: left;
}
.fi-brand-color-picker .color-preview-card .color-preview-label {
  line-height: 100px;
  font-size: 12px;
  color: var(--fi-color-white);
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-site-design/fi-site-design-settings/fi-site-design-brand-editor/fi-brand-editor-brand-colors-card/fi-brand-color-picker/fi-brand-color-picker.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAR;AAGY;EACI,UAAA;AADhB;AAKQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;AAHZ;AAMQ;EACI,UAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAJZ;AAOQ;EACI,SAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;AALZ;AAOY;EACI,WAAA;AALhB;AASQ;EACI,kBAAA;EACA,eAAA;EACA,4BAAA;AAPZ","sourcesContent":[".fi-brand-color-picker {\r\n    .color-preview-card {\r\n        display: inline-block;\r\n        margin-right: 20px;\r\n        width: 100px;\r\n        height: 100px;\r\n        text-align: center;\r\n        border-radius: 10px;\r\n        margin-bottom: 10px;\r\n        position: relative;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            .paint-icon {\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n        .paint-icon {\r\n            position: absolute;\r\n            top: 10px;\r\n            right: 10px;\r\n            opacity: 0;\r\n            transition: 0.2s;\r\n            color: var(--fi-color-white);\r\n        }\r\n\r\n        .color-picker-trigger {\r\n            opacity: 0;\r\n            position: absolute;\r\n            bottom: 0;\r\n            left: 50%;\r\n        }\r\n\r\n        .color-picker-button {\r\n            margin: 0;\r\n            font-size: 12px;\r\n            border: none;\r\n            background: transparent;\r\n\r\n            &.cancel {\r\n                float: left;\r\n            }\r\n        }\r\n\r\n        .color-preview-label {\r\n            line-height: 100px;\r\n            font-size: 12px;\r\n            color: var(--fi-color-white);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
